import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "single-room-content" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "room__meta room__meta--lg" }
const _hoisted_7 = { class: "room__meta-item" }
const _hoisted_8 = { class: "room__meta-item-value" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "room__meta-item-label" }, "Players", -1)
const _hoisted_11 = { class: "room__meta-item" }
const _hoisted_12 = { class: "room__meta-item-value" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-clock" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "room__meta-item-label" }, "Minutes", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("h3", null, "Why not go head-to-head?", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("With ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(", we have two identical rooms, meaning you can go ")
const _hoisted_20 = /*#__PURE__*/_createVNode("em", null, "head-to-head", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" against your friends & colleagues. Perfect for parties or team building events.")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("If you wish to play head-to-head, simply ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" and book both ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" for the same time slot.")
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If the time slot you require is not available, or you are interested in booking an event out of our usual business hours, please "),
  /*#__PURE__*/_createVNode("a", { href: "mailto:info@project-escape.co.uk" }, "contact us via email"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "/img/sectigo.png",
    alt: "Secured by Sectigo"
  })
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "/img/sectigo.png",
    alt: "Secured by Sectigo"
  })
], -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "room-details" }
const _hoisted_31 = { class: "room-details__item" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_33 = { class: "room-details__item" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope" }, null, -1)
const _hoisted_35 = { class: "room-details__item" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fa fa-map-marker" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(" 2-" + _toDisplayString(_ctx.room.maxPlayers), 1)
                ]),
                _hoisted_10
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(" " + _toDisplayString(_ctx.room.time), 1)
                ]),
                _hoisted_14
              ])
            ]),
            _createVNode("div", {
              innerHTML: _ctx.room.description
            }, null, 8, ["innerHTML"]),
            (_ctx.room.video)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("iframe", {
                    width: "560",
                    height: "315",
                    src: _ctx.room.video,
                    style: {"display":"block","margin":"0 auto 20px"},
                    frameborder: "0",
                    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: ""
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.room.headToHead)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode("p", null, [
                    _hoisted_18,
                    _createVNode("strong", null, _toDisplayString(_ctx.name), 1),
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21
                  ]),
                  _createVNode("p", null, [
                    _hoisted_22,
                    _createVNode("a", {
                      href: '/' + _ctx.location + '/booking'
                    }, "visit our booking page", 8, ["href"]),
                    _hoisted_23,
                    _createVNode("strong", null, _toDisplayString(_ctx.name) + " Room A and " + _toDisplayString(_ctx.name) + " Room B", 1),
                    _hoisted_24
                  ]),
                  _hoisted_25
                ]))
              : _createCommentVNode("", true),
            (_ctx.room.resovaId)
              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode("div", {
                    id: "resova-wrapper",
                    "data-id": _ctx.room.resovaId
                  }, null, 8, ["data-id"]),
                  _hoisted_28
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("ul", _hoisted_30, [
              _createVNode("li", _hoisted_31, [
                _hoisted_32,
                _createVNode("a", {
                  href: 'tel:' + _ctx.phone
                }, _toDisplayString(_ctx.phone), 9, ["href"])
              ]),
              _createVNode("li", _hoisted_33, [
                _hoisted_34,
                _createVNode("a", {
                  href: 'mailto:' + _ctx.email
                }, _toDisplayString(_ctx.email), 9, ["href"])
              ]),
              _createVNode("li", _hoisted_35, [
                _hoisted_36,
                _createTextVNode(" " + _toDisplayString(_ctx.address.join(", ")), 1)
              ])
            ]),
            _createVNode("a", {
              href: '/' + _ctx.location + '/booking',
              class: "btn btn-primary btn-lg"
            }, "Book Now!", 8, ["href"])
          ])
        ])
      ])
    ])
  ]))
}